import { render, staticRenderFns } from "./ReceivingList.vue?vue&type=template&id=8b77ce78&scoped=true"
import script from "./ReceivingList.vue?vue&type=script&lang=js"
export * from "./ReceivingList.vue?vue&type=script&lang=js"
import style0 from "./ReceivingList.vue?vue&type=style&index=0&id=8b77ce78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b77ce78",
  null
  
)

export default component.exports